export const getCategoriesById = (arr = [], ids = []) => {
  return arr.filter(i => ids.includes(i.id))
}
